import MobileCard from './MobileCard';

export default MobileCard;
